"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});
var e = require("react"),
  n = require("@soywod/pin-field");
function t() {
  return (t = Object.assign || function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];
      for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }).apply(this, arguments);
}
var r = ["className", "ref", "length", "validate", "format", "debug", "onResolveKey", "onRejectKey", "onChange", "onComplete"];
function o() {}
var a = {
    ref: {
      current: new n.PinField()
    },
    length: 5,
    validate: /^[a-zA-Z0-9]$/,
    format: function format(e) {
      return e;
    },
    debug: !1,
    onResolveKey: o,
    onRejectKey: o,
    onChange: o,
    onComplete: o
  },
  u = e.forwardRef(function (o, u) {
    var c = e.useRef(new n.PinField()),
      i = t({}, a, o),
      l = i.className,
      s = i.length,
      f = i.validate,
      v = i.format,
      d = i.debug,
      m = i.onResolveKey,
      y = i.onRejectKey,
      p = i.onChange,
      g = i.onComplete,
      E = function (e, n) {
        if (null == e) return {};
        var t,
          r,
          o = {},
          a = Object.keys(e);
        for (r = 0; r < a.length; r++) n.indexOf(t = a[r]) >= 0 || (o[t] = e[t]);
        return o;
      }(i, r);
    function h(e) {
      e instanceof CustomEvent && p(e.detail.value);
    }
    function b(e) {
      e instanceof CustomEvent && m(e.detail.key);
    }
    function j(e) {
      e instanceof CustomEvent && y(e.detail.key);
    }
    function C(e) {
      e instanceof CustomEvent && g(e.detail.value);
    }
    return e.useImperativeHandle(u, function () {
      return c.current;
    }, [c]), e.useEffect(function () {
      if (c.current) return c.current.validate = f, c.current.format = v, c.current.addEventListener("change", h), c.current.addEventListener("resolve-key", b), c.current.addEventListener("reject-key", j), c.current.addEventListener("complete", C), function () {
        c.current && (c.current.removeEventListener("change", h), c.current.removeEventListener("resolve-key", b), c.current.removeEventListener("reject-key", j), c.current.removeEventListener("complete", C));
      };
    }, []), e.createElement("swd-pin-field", t({
      ref: c,
      class: l,
      length: s,
      debug: d ? "" : void 0
    }, E));
  });
Object.keys(n).forEach(function (e) {
  "default" !== e && Object.defineProperty(exports, e, {
    enumerable: !0,
    get: function get() {
      return n[e];
    }
  });
}), exports.ReactPinField = u, exports.default = u;